import React, { useState, useRef, useEffect } from 'react';
import {validateLineItem} from "../../Validations";
import {Formik} from "formik";
import { useEvaluateStep } from '../../../hooks/useEvaluateStep';
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import ItemsGrid from "../../../common/components/widgets/ItemsGrid";
import LineItemForm from "../../campaign/LineItemForm";
import {Builder} from "../../../settings/builder";
import {Simulation} from "./simulationHelpers";
import {lineItemGridColumns} from "../../../settings/dataSets";
import RouterPropsWrapper from '../../../common/RouterPropsWrapper'
import {lineItemsInitValues} from "../../placement/InitValues";
import { creativesVar, lineItemsVar } from '../../../settings/cache';

export const dontshow = () => {return true};


const LineItemsSimulation = (props) => {
  const { match, history, items: propsItems, name: propsName, submit: propsSubmit, changeTime, isSubmitting, id } = props;
  
  const [items, setItems] = useState(propsItems || []);
  const [currentTab, setCurrentTab] = useState(1);
  const [name, setName] = useState(propsName || '');
  const [editMode, setEditMode] = useState(false);
  const [initialValues, setInitialValues] = useState(lineItemsInitValues);
  const [checkIndex, setCheckIndex] = useState(true);
  const [index, setIndex] = useState(null);
  
  const ResetLineItemForm = useRef();
  const evaluateStepMutation = useEvaluateStep();

  useEffect(() => {
    if (propsName) {
      setName(propsName);
    }
  }, [propsName]);

  const deleteRow = (index) => {
    // Not implemented
  };

  const editLineItem = (index, item) => {
    console.log(item);
    setEditMode(true);
    setInitialValues(item);
    setIndex(index);
  };

  const resetLineItemForm = () => {
    document.getElementById("LineItemFormInput").reset();
    ResetLineItemForm.current.resetLineItemForm();
  };

  const saveLineItem = async (values, setSubmitting) => {
    setSubmitting(false);
    let itemIndex = items.length;
    let item = Builder.getLineItem(values);
    let creatives = creativesVar();
    item = {...item, label: item.name, secondaryLabel: "...", creatives};
    const data = Simulation.getSimulatedLineItem(item);
    
    const newItems = [...items];
    if (editMode === true) {
      lineItemsVar(newItems);
      newItems.splice(index, 1, values);
      setItems(newItems);
      setEditMode(false);
    } else {
      lineItemsVar(newItems);
      newItems.splice(itemIndex, 0, values);
      if (itemIndex === 1) {
        setCheckIndex(false);
      }
      setItems(newItems);
    }

    creativesVar([]);
    resetLineItemForm();
    
    const action = {
      actionNeeded: 'complete',
      target: JSON.stringify({
        type: "lineitem",
        fields: data
      })
    };
    
    try {
      let res = await evaluateStepMutation.mutateAsync({
        challengeId: id,
        action: action,
        challengeToDo: null
      });
      let value = res.challengeStepEvaluator?.targetLocation || '';
      if (value !== '') {
        history.push(value + match.params.id);
      }
    } catch (error) {
      console.error('Error evaluating step:', error);
    }
    
    setInitialValues(lineItemsInitValues);
    if (changeTime) changeTime();
  };

  const updateRow = (index, values) => {
    const newItems = [...items];
    lineItemsVar(newItems);
    newItems.splice(index, 1, values);
    setItems(newItems);
  };

  const submit = () => {
    if (!isSubmitting && propsSubmit) {
      propsSubmit();
    }
  };

  return (
    <div>
      <Card>
        <div>
          <AppBar position="static" color="default">
            <Tabs value={currentTab} >
              <Tab disableRipple label="Campaign"/>
              <Tab disableRipple label="Line Items" disabled={!name}/>
            </Tabs>
          </AppBar>
        </div>
        <CardContent>
          {currentTab === 1 && <div>
            <div>
              <ItemsGrid columns={lineItemGridColumns} title="Line Items" items={items} remove={deleteRow} edit={editLineItem} response="true" />
              <Formik
                initialValues={initialValues}
                validate={validateLineItem}
                onSubmit={(values, {setSubmitting}) => saveLineItem(values, setSubmitting)}
                enableReinitialize
              >
                {({values, errors, handleChange, touched, setFieldValue}) => (
                  <LineItemForm simulation={true} values={values} errors={errors} handleChange={handleChange} touched={touched} ref={ResetLineItemForm} setFieldValue={setFieldValue} />
                )}
              </Formik>
            </div>
          </div>}
          <div className="card-footer">
            {/* <div className="ml-auto">
              {
                currentTab === 1 &&
                <button className="btn btn-fill btn-rose" >Previous</button>
              }
            </div> */}
            <div className="ml-auto mr-auto">
              <button disabled={checkIndex} className="btn btn-fill btn-rose" onClick={submit}>
                Save Campaign
              </button>
            </div>
            <div className="clearfix"></div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default RouterPropsWrapper(LineItemsSimulation);
